enum AttributionWebVisitsTableReport {
  Date = 'attribution_web_visits_table_date',
  Channel = 'attribution_web_visits_table_channel',
  Device = 'attribution_web_visits_table_device',
  Campaign = 'attribution_web_visits_table_campaign',
  Placement = 'attribution_web_visits_table_placement',
  Pixels = 'attribution_web_visits_table_pixels',
  Creative = 'attribution_web_visits_table_creative',
  Publisher = 'attribution_web_visits_table_publisher',
  DayOfWeek = 'attribution_web_visits_table_day_of_week',
  Daypart = 'attribution_web_visits_table_daypart',
}

export default AttributionWebVisitsTableReport;
